import { render, staticRenderFns } from "./ProjectProducts.vue?vue&type=template&id=2eb24ab0&scoped=true"
import script from "./ProjectProducts.vue?vue&type=script&lang=js"
export * from "./ProjectProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb24ab0",
  null
  
)

export default component.exports